
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#d20311","stroke-width":"0px"},attrs:{"d":"m47.19,0h-30.36C7.54,0,0,6.2,0,13.84v35.64c0,8.03,7.9,14.52,17.66,14.52h29.53c9.29,0,16.83-6.18,16.81-13.82V13.82c0-7.64-7.52-13.82-16.81-13.82Zm13.81,50.18c0,3.06-1.58,5.3-2.92,6.64-2.65,2.66-6.62,4.18-10.89,4.18h-29.53c-8.08,0-14.66-5.17-14.66-11.52V13.84c0-5.98,6.2-10.84,13.83-10.84h30.36c7.61,0,13.81,4.85,13.81,10.82v36.36Zm-28.98-9.06c-1.14.29-2.29-.4-2.57-1.54l-1.08-4.29c-.17-.67,0-1.37.45-1.9.45-.52,1.12-.79,1.81-.73.79.07,1.66,0,2.45-.2,3.94-.99,6.34-5.01,5.35-8.95-.99-3.94-5.01-6.34-8.95-5.35-3.92.99-6.32,4.99-5.36,8.91.28,1.13-.41,2.28-1.54,2.56h-.01c-1.14.28-2.29-.41-2.57-1.55-1.52-6.19,2.26-12.49,8.44-14.04,6.21-1.56,12.53,2.22,14.1,8.43,1.56,6.21-2.22,12.53-8.43,14.1-.33.08-.66.15-.99.2l.44,1.76c.29,1.14-.4,2.29-1.54,2.57v.02Zm.86,3.4c-1.87.47-3,2.36-2.53,4.23.47,1.87,2.36,3,4.23,2.53,1.87-.47,3-2.36,2.53-4.23s-2.36-3-4.23-2.53Z"}})])
          )
        }
      }
    